/**
 * 사용자 관련 상수 및 타입 정의
 */

import { ContractStep } from "src/api/contract/contract-types";

/**
 * 초대 가능한 계약 단계 목록
 * 사용자 초대가 가능한 계약 상태를 정의합니다.
 */
export const INVITEABLE_CONTRACT_STEP = [
  // ContractStep.CONTRACT_ACCEPT,
  ContractStep.USE_APPROVAL,
  ContractStep.USE_PROGRESS,
  ContractStep.TERMINATE_RECEIVED,
];

/**
 * 사용자 상태 타입 매핑
 * 사용자의 상태를 나타내는 타입과 표시 텍스트를 매핑합니다.
 */
export const USER_STATUS_TYPE_MAP = {
  MEMBER_INVITE: "초대",
  MEMBER_USE: "사용",
  MEMBER_DELETE: "삭제",
  MEMBER_CLOSE: "사용종료",
  MEMBER_EXPIRE: "초대만료",
};

/**
 * 초대경로 코드 → 서비스명 매핑
 * 서비스명 표기 규칙(https://pnpt.atlassian.net/wiki/x/AoABU)에 따라 코드값 대신 서비스명을 노출한다
 *
 * CTRL_ROOM  : Ctrl.room 파트너 회원이 이용자를 초대한 경우
 * MOBILE_APP : Mobile App 에서 계약자/마스터가 이용자를 초대한 경우
 */
export const INVITATION_CHANNEL_LABEL_MAP: Record<string, string> = {
  CTRL_ROOM: "Ctrl.Room",
  MOBILE_APP: "Mobile App",
};

/**
 * 초대경로 표시값 반환
 * 매핑에 없는 코드는 원본 그대로 노출해 신규 채널 추가 시에도 값이 사라지지 않게 한다
 */
export const getInvitationChannelLabel = (channel?: string) => {
  if (!channel) return "-";
  return INVITATION_CHANNEL_LABEL_MAP[channel] ?? channel;
};

/**
 * 초대경로 검색 옵션
 */
export const INVITATION_CHANNEL_OPTIONS = [
  { label: "전체", value: "" },
  { label: INVITATION_CHANNEL_LABEL_MAP.CTRL_ROOM, value: "CTRL_ROOM" },
  { label: INVITATION_CHANNEL_LABEL_MAP.MOBILE_APP, value: "MOBILE_APP" },
];

export const INVITE_EXPIRE_DAYS_OPTIONS = [
  { label: "3일", value: 3 },
  { label: "일주일", value: 7 },
  { label: "1개월", value: 30 },
  { label: "3개월", value: 90 },
  { label: "6개월", value: 180 },
];
